module.exports = "https://web-assets.ifttt.com/packs/media/partners/gear-f8fb5621.svg";